module.exports = __webpack_public_path__ + "static/media/solution-img2.5bdcf50a.png";